/**
 * A janela do som — parte D1 (01/10/2026): no máximo 1 som a cada 5 s, somando todas as
 * abas (`localStorage["seweb:ultimo-som"]`, gravado ANTES de tocar). Sem localStorage, a
 * janela vale por aba (spec §9). O armazém é parâmetro pelo mesmo motivo do
 * `somDoAparelho` (o Storage do happy-dom é um Proxy).
 */
import { armazemPadrao, type Armazem } from "./somDoAparelho";

export const CHAVE_DO_ULTIMO_SOM = "seweb:ultimo-som";
export const JANELA_DO_SOM_MS = 5000;

let ultimoNestaAba = 0;

/** Reserva a janela para tocar agora. `false` = outro som saiu há menos de 5 s. */
export function reservarJanelaDoSom(
  agora: number = Date.now(),
  armazem: Armazem | null = armazemPadrao()
): boolean {
  let ultimo = ultimoNestaAba;
  let gravavel = armazem !== null;
  if (armazem) {
    try {
      const bruto = Number(armazem.getItem(CHAVE_DO_ULTIMO_SOM));
      // Marca no futuro (relógio mexido) não pode calar o som para sempre.
      if (Number.isFinite(bruto) && bruto <= agora) ultimo = Math.max(ultimo, bruto);
    } catch {
      gravavel = false;
    }
  }
  if (agora - ultimo < JANELA_DO_SOM_MS) return false;
  ultimoNestaAba = agora;
  if (gravavel && armazem) {
    try {
      armazem.setItem(CHAVE_DO_ULTIMO_SOM, String(agora));
    } catch {
      // vale a janela desta aba
    }
  }
  return true;
}

/** Só para os testes. */
export function _reiniciarJanelaParaTeste(): void {
  ultimoNestaAba = 0;
}
